import { render, staticRenderFns } from "./promo_menu.vue.js?vue&type=template&id=37e2df5a!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./promo_menu.vue?vue&type=template&id=37e2df5a"
import script from "./promo_menu.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./promo_menu.vue?vue&type=script&lang=js"
export * from "./promo_menu.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./promo_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37e2df5a')) {
      api.createRecord('37e2df5a', component.options)
    } else {
      api.reload('37e2df5a', component.options)
    }
    module.hot.accept("./promo_menu.vue.js?vue&type=template&id=37e2df5a!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./promo_menu.vue?vue&type=template&id=37e2df5a", function () {
      api.rerender('37e2df5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "super_sidebar/components/promo_menu.vue"
export default component.exports